export default {
  giftCardPhase: (state) => state.appPhase,
  giftCardForm: (state) => state.form,
  giftCardActivation: (state) => state.activation,

  isGiftCardSubmitting: (state) => state.loading.submit,

  giftCardSubmitError: (state) => state.errors.submit,
  giftCardFieldErrors: (state) => state.errors.fields,

  // Helpers de validation
  giftCardCanSubmitIdentity: (state) => {
    const f = state.form;
    const base =
      f.civility &&
      f.firstName.trim() &&
      f.lastName.trim() &&
      f.phoneNumber.trim();
    if (f.sameAsWhatsapp) return !!base;
    return !!(base && f.waNumber.trim());
  },

  giftCardCanSubmitAuto: (state) => {
    const f = state.form;
    if (f.hasAuto === null) return false;
    if (f.hasAuto === true && !f.autoExpiryDate) return false;
    return true;
  },

  giftCardCanSubmitHome: (state) => {
    const f = state.form;
    if (f.hasHome === null) return false;
    if (f.hasHome === true && !f.homeExpiryDate) return false;
    return true;
  },
};
